import { select, put } from 'redux-saga/effects';
import { MANAGE_PRODUCT_IN_COMPARE_LIST } from '../actions';
import { CompareActions } from '../types';
import { getUserLastActionData } from '../selectors';

export function* retryLastActionSaga(): Generator {
  const userLastActionData = yield select(getUserLastActionData);

  if (userLastActionData.productId && userLastActionData.groupId) {
    yield put(
      MANAGE_PRODUCT_IN_COMPARE_LIST({
        action: userLastActionData.action === 'request' ? CompareActions.ADD : userLastActionData.action,
        productId: userLastActionData.productId,
        familyId: userLastActionData.groupId,
        groupName: userLastActionData.groupName,
        withData: false,
      }),
    );
  }
}
